import { useEffect } from "react";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, canonical, jsonLd }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    if (description) setMeta("description", description);
    let link = document.querySelector('link[rel="canonical"]');
    const prevCanonical = link?.getAttribute("href");
    if (canonical && link) link.setAttribute("href", canonical);
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = prevTitle;
      if (prevCanonical && link) link.setAttribute("href", prevCanonical);
      if (script) script.remove();
    };
  }, [title, description, canonical, jsonLd]);
};
